// Small inline loading spinner (animation honors prefers-reduced-motion via the
// global rule in theme.css). Used in buttons and loading states.

interface Props {
  size?: number;
  label?: string;
}

export function Spinner({ size = 18, label }: Props) {
  return (
    <span
      className="spinner"
      style={{ width: size, height: size }}
      role="status"
      aria-label={label ?? "Loading"}
    />
  );
}

/** A row of shimmer placeholder cards for list loading states. */
export function CardSkeletons({ count = 6 }: { count?: number }) {
  return (
    <div className="doc-grid" aria-hidden="true">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="skeleton-card" />
      ))}
    </div>
  );
}
